<template>
  <div class="formate-box">
    <span class="formate-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27.556"
        height="36.75"
        viewBox="0 0 27.556 36.75"
      >
        <path
          fill="#898989"
          class="a"
          d="M26.545-5.22l-6.021-6.021a3.445,3.445,0,0,0-2.433-1.012H3.445A3.456,3.456,0,0,0,0-8.8V21.053A3.445,3.445,0,0,0,3.445,24.5H24.112a3.445,3.445,0,0,0,3.445-3.445V-2.78A3.461,3.461,0,0,0,26.545-5.22ZM24.923-3.591a1.129,1.129,0,0,1,.3.531H18.371V-9.913a1.129,1.129,0,0,1,.531.3ZM24.112,22.2H3.445A1.152,1.152,0,0,1,2.3,21.053V-8.8A1.152,1.152,0,0,1,3.445-9.949h12.63v7.463A1.718,1.718,0,0,0,17.8-.763H25.26V21.053A1.152,1.152,0,0,1,24.112,22.2ZM20.667,4.691a.864.864,0,0,0-.861-.861H7.75a.864.864,0,0,0-.861.861v.574a.864.864,0,0,0,.861.861H19.806a.864.864,0,0,0,.861-.861Zm0,4.593a.864.864,0,0,0-.861-.861H7.75a.864.864,0,0,0-.861.861v.574a.864.864,0,0,0,.861.861H19.806a.864.864,0,0,0,.861-.861Zm0,4.593a.864.864,0,0,0-.861-.861H7.75a.864.864,0,0,0-.861.861v.574a.864.864,0,0,0,.861.861H19.806a.864.864,0,0,0,.861-.861Z"
          transform="translate(0 12.253)"
        />
      </svg>
    </span>
  </div>
</template>
<script>
export default {
  name: 'DefaultViewer',
};
</script>
